export class GetBranchByLocationModel {
    provinceId: number;
    districtId: number;
    allowBooking: boolean;
}

export class GetInformationBookingModel {
    branchCode: string;
    bookingDate: Date;
    bookingTimeId: number;
}

export class AddEditBookingModel {
    id: number;
    customerCode: string;
    customerIdentity: string;
    customerName: string;
    phone: string;
    email: string;
    dateOfBirth: string;
    address: string;
    branchCode: string;
    bookingTimeId: any;
    bookingCode: string;
    bookingDate: string;
    status: number;
    productId: string;
    productGroupId: string;
    formCode: string;
    formData: CreateIssueModel;
    bookingSource: string;
    acceptTermsConditions: boolean;
}

export class RepresentativeModel {
    id: number;
    qrCode: string;
    customerName: string;
    companyName: string
    taxCode: string;
    position: string;
    phone: string;
    email: string;
    branchCode: string;
    status: number;
    productId: string;
    productGroupId: string;
    formName: string;
    formCode: string;
}

export class QRCodeModel {
    QRCode: string;
}

export class CreateIssueModel {
    id: number;
    customerCode: string;
    customerIdentity: string;
    customerName: string;
    formCode: string;
    phone: string;
    email: string;
    dateOfBirth: string;
    dateOfIssue: string;
    placeOfIssue: string;
    nationality: string;
    gender: string;
    permanentAddress: string;
    currentAddress: string;
    currentAddressCountry: string;
    currentAddressProvince: string;
    currentAddressDistrict: string;
    homeNo: string;
    maritalStatus: string;
    occupation: string;
    position: string;
    companyName: string;
    companyAddress: string;
    customFieldData: FieldValue[];
    environment: number;
    permanentAddressProvince: string;
    permanentAddressCountry: string;
    permanentAddressDistrict: string
}

export class FieldValue {
    code: string;
    value: string;
    rowId: number;
}
export class FieldTableValue {
    rowId: number;
    code: string;
    value: string;
}